export const localValidate = (formState) => {
  let errors = {};

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Organization is required';
  }

  if (formState.seasonId < 0) {
    errors.seasonId = 'Season Year is required';
  }

  return errors;
};

const ClubMembershipDetailReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ClubMembershipDetailReportValidation;